import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  className = '',
  label,
  error,
  ...props
}: TextareaProps) {
  return <div className="w-full" data-id="element-243">
      {label && <label className="mb-2 block text-sm font-medium text-gray-700" data-id="element-244">
          {label}
        </label>}
      <textarea className={`flex min-h-[80px] w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm font-body text-gray-900 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF1493] focus-visible:border-[#FF1493] disabled:cursor-not-allowed disabled:opacity-50 transition-colors ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-245" />
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-246">{error}</p>}
    </div>;
}